import React from 'react';
import { useHistory } from 'react-router-dom';
import App from '@app';
import { Body, PageHeader, AddButton } from '@components';
import TableComandos from './TableComandos';

export default function Comandos() {
  const history = useHistory();

  return (
    <App>
      <Body>
        <PageHeader
          title="Comandos"
          extra={[
            <AddButton
              key="1"
              type="primary"
              tooltipTitle="Adicionar Comando"
              style={{ marginBottom: 10 + 'px', borderRadius: 5 + 'px' }}
              onClick={() => history.push('/conectores/comando/-1')}
            />,
          ]}
        >
          <TableComandos />
        </PageHeader>
      </Body>
    </App>
  );
}
